import React from "react";

function FooterClient() {
  return null;
}

export default FooterClient;
